import { useState, useEffect, useCallback} from 'react';
import { Typography, Paper, Button, Badge, Switch, FormControlLabel, Box} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import MiTabla from '../../components/plantilla/tabla/MiTabla';

import Criteria from './modales/Criteria';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CancelIcon from '@mui/icons-material/Cancel';
import Swal from 'sweetalert2';
import useMediaQuery from '@mui/material/useMediaQuery';
import SubirPrice from './modales/SubirPrice';

import { Tabs, Tab } from '@mui/material';

const Stops = () => {

    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [data, setData] = useState([]);

    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const [statusFilter, setStatusFilter] = useState('ALL');

    const [onlyLovesFuelStations, setOnlyLovesFuelStations] = useState(false);

    const [onlyWithCriteria, setOnlyWithCriteria] = useState(false);

    const [updatingStatusId, setUpdatingStatusId] = useState(null);

    const [loading, setLoading] = useState(false);

    const [priceModalOpen, setPriceModalOpen] = useState(false);

    const handleOpenModal = (modal, stop = null) => 
    {
        if(modal === 'PRICE')
            setPriceModalOpen(true);
        else 
        {
            setSelected(stop);
            setModalOpen(true);
        }
    };

    const handleOpenCriteria = useCallback(async (stopRow) => 
    {
        handleOpenModal(data.find(stop => stop.id === stopRow.id));
        setSelected(stopRow);
        
    }, []);

    const UpdateStatus = async (id, value) => 
    {
        setUpdatingStatusId(id);
        try 
        {
            const response = await myApi.put('/loves/stops/estatus', { id, estatus_ebt: value });

            if (response.data.success) 
            {
                /*
                //await fetchData();
                
                // Actualiza solo la fila modificada localmente
                setData(prevData => 
                    prevData.map(item => 
                        item.id === id ? { ...item, status: value } : item
                    )
                );
                */
                try 
                {
                    const updatedStop = await myApi.get(`/loves/stops/${id}`);

                    setData(prev =>
                        prev.map(item =>
                            item.id === id ? updatedStop.data.data[0] : item
                        )
                    );
                } 
                catch 
                {
                    // fallback
                    await fetchData();
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Actualizado',
                    text: 'El estatus fue actualizado',
                    timer: 1000,
                    showConfirmButton: false,
                });
            } 
            else 
            {
                throw new Error('Fallo la actualización');
            }
        } 
        catch(error) 
        {
            console.error('Error al actualizar:', error);
            Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo actualizar el estatus.',
            });
        }
        finally 
        {
            setUpdatingStatusId(null);
        }
    };

    const StatusSwitchCell = ({ value, id, onUpdate, loading }) => 
    {
        const [checked, setChecked] = useState(value === 'Primary');

        useEffect(() => 
        {
            setChecked(value === 'Primary');
        }, [value]);

        const handleChange = (event) => 
        {
            const newValue = event.target.checked;
            setChecked(newValue);

            if (newValue !== (value === 'Primary')) 
                onUpdate(id, newValue ? 'Primary' : 'Inactive');
        };

        return (
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={handleChange}
                        color="primary"
                        disabled={loading}
                    />
                }
                label={checked ? 'Primary' : 'Inactive'}
            />
        );
    };    

    const columns = [
        {
            field: 'truck_stop_code', headerName: 'STOP CODE',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'store', headerName: 'STORE',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'truck_stop_type', headerName: 'TYPE',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'name', headerName: 'NAME',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'address', headerName: 'ADDRESS',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'city', headerName: 'CITY',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'state', headerName: 'STATE',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'postal_code', headerName: 'POSTAL CODE',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { field: 'highway_exit', headerName: 'HIGHWAY EXIT',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'status',
            headerName: 'STATUS',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <StatusSwitchCell 
                    value={params.value}
                    id={params.id}
                    onUpdate={UpdateStatus}
                    loading={updatingStatusId === params.id}
                />
            )
        },
        {
            field: 'criteria',
            headerName: 'CRITERIA',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Button
                    onClick={() => handleOpenCriteria(params.row)}
                    variant="text"
                    sx={{ minWidth: 0, padding: 0 }}
                >
                    <Badge badgeContent={params.value} color={params.value > 0 ? "success" : "default"}>
                        {params.value > 0 ? <CheckCircleIcon color="success" /> : <CancelIcon color="disabled" />}
                    </Badge>
                </Button>
            )
        }
    ];

    const fetchData = async () => 
    {
        setLoading(true);
        try 
        {
            const response = await myApi.get('/loves/getStops');
            if(response)
            {
                if(response.data.data === 'No hay paradas')
                    setData([]);
                else
                    setData(response.data.data);
            }
            else
                setData([]);
        } 
        catch(error) 
        {
            console.error('Error fetching stops:', error);
            setData([]);
        } 
        finally 
        {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
    <Paper 
        sx={{
            p: 2, 
            width: "100%",
            height: "100%",
            display: "flex", 
            flexDirection: "column",
            boxSizing: "border-box",
            overflow: "hidden"
        }}
    >
        <Box sx={{ flexShrink: 0 }}>
            <Tabs
                value={statusFilter}
                onChange={(e, newValue) => setStatusFilter(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant="standard"
                sx={{ mb: 1 }}
            >
                <Tab label="TODOS" value="ALL" />
                <Tab label="ACTIVOS" value="Primary" />
                <Tab label="INACTIVOS" value="Inactive" />
            </Tabs>

            <Grid container spacing={2} direction="row" sx={{ mb: 1 }}>
                <Grid>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={onlyLovesFuelStations}
                                onChange={(e) => setOnlyLovesFuelStations(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Solo Love's Fuel Stations"
                    />
                </Grid>
                <Grid>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={onlyWithCriteria}
                                onChange={(e) => setOnlyWithCriteria(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Con Criterio"
                    />
                </Grid>
            </Grid>

            <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                LOVE'S STOPS
            </Typography>

            <Button
                type="button"
                color="inherit"
                variant="contained"
                startIcon={<UploadFileIcon />}
                onClick={() => handleOpenModal('PRICE')}
                sx={{ color: "primary", fontWeight: "bold", mb: 2 }}
            >
                Subir Prices
            </Button>
        </Box>

        {/* CONTENEDOR CON ALTO FIJO CALCULADO PARA EVITAR QUE SE DESBORDE ABAJO */}
        <Box 
            sx={{ 
                width: "100%",
                height: "calc(100vh - 350px)", 
                minHeight: 350,
                display: "flex",
                flexDirection: "column",
                "& > div": { height: "100%", width: "100%" } 
            }}
        >
            <MiTabla
                columns={columns}
                data={
                    data.filter((row) => {
                        const statusMatches =
                            statusFilter === 'ALL' || row.status === statusFilter;

                        const lovesFuelMatches =
                            !onlyLovesFuelStations ||
                            (row.truck_stop_type === 'Fuel Station' &&
                            row.name?.toLowerCase().includes("love"));

                        const criteriaMatches =
                            !onlyWithCriteria || (row.criteria && row.criteria > 0);

                        return statusMatches && lovesFuelMatches && criteriaMatches;
                    })
                }
                loading={loading}
            />
        </Box>

        {/* MODALES */}
        <Criteria
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            refreshStops={fetchData} 
            idStop={selected?.truck_stop_code}
        />
        <SubirPrice
            open={priceModalOpen}
            onClose={() => setPriceModalOpen(false)} 
        />
    </Paper>
);
}

export default Stops